export default class Cargo {
  _id = "" || undefined;
  nome = "";
  descricao = "";
}
